import moment from "moment";
import React, { useState, Fragment, useRef, useEffect } from "react";
import { Button, Modal, Image, Row, Col } from "react-bootstrap";
import { CAR_COLORS, ORDER_TYPE_NAME } from "../../../enums/OrderEnums";
import ReactHtmlParser from "react-html-parser";
import { useReactToPrint } from "react-to-print";
import { Radio, TextField } from "@material-ui/core";
import axios from "axios";
import { serverApi } from "../../../config/Keys";
import { errorAlert } from "../../../function/alert";
import { SmallLoader } from "../../Loader/SmallLoader";
import DeliveryPerson from "./DeliveryPerson";
import { add_delivery_person } from "../../../store/actions/DeliveryPersonActions/DeliveryPersonActions";
import { useDispatch } from "react-redux";
import AddOrEditDeliveryPersonModal from "../DeliveryPersonReuseComponent/AddOrEditDeliveryPersonModal";

function AssignDeliveryPerson(props) {
  const [open, setOpen] = useState(false);
  const [deliveryPersons, setDeliveryPersons] = useState([]);
  const [noDeliveryPerson, setNoDeliveryPerson] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedDeliveryPerson, setSelectedDeliveryPerson] = useState({});
  const [thirdParty, setThirdParty] = useState(false);

  const getDeliveryPersons = async () => {
    setNoDeliveryPerson(false);
    setLoading(true);
    const response = await axios.get(`${serverApi}/delivery-persons`, {
      headers: { Authorization: props?.accessToken },
    });
    if (response.status == 200) {
      setDeliveryPersons(response.data);
    } else {
      setNoDeliveryPerson(true);
    }
    setLoading(false);
  };
  //console.log(props);
  useEffect(() => {
    if (open) getDeliveryPersons();
  }, [open]);

  useEffect(() => {
    if (props?.data?.selfDeliveryPerson) {
      setSelectedDeliveryPerson({ _id: props?.data?.selfDeliveryPerson });
    }
  }, [props?.selfDeliveryPerson, deliveryPersons]);

  const [trackingUrl, setTrackingUrl] = useState("");
  const onSubmit = async (alreadyAssigned) => {
    //start

    // const packingStage = props?.data?.order_status === 3;
    // let finalData = {
    //   ...(packingStage ? { order_status: props?.data?.order_status + 1 } : {}),
    //   id: props?.data?._id,
    // };
    //end
    let finalData = {
      id: props?.data?._id,
    };
    if (alreadyAssigned != true) {
      finalData = {
        ...finalData,
        selfDeliveryPerson: selectedDeliveryPerson?._id,
        deliveryPerson: {
          name:
            selectedDeliveryPerson?.full_name ||
            props?.data?.deliveryPerson?.name ||
            "",
          link: "",
          phoneNumber:
            selectedDeliveryPerson?.country_code +
              selectedDeliveryPerson?.mobile_number ||
            props?.data?.deliveryPerson?.phoneNumber ||
            "",
        },
      };
    }

    if (!props?.iconButton) {
      finalData = {
        ...finalData,
        order_status: 4,
      };
    }

    if (selectedDeliveryPerson?._id) {
      let response = await axios.patch(
        `${serverApi}/ordering/${finalData?.id}`,
        finalData,
        {
          headers: { Authorization: props?.accessToken },
        }
      );
      if (response.status == 200) {
        setOpen(false);
        if (props?.getUpdatedData) props.getUpdatedData();
      } else {
        errorAlert("Something went wrong!");
      }
    } else if (thirdParty && trackingUrl) {
      finalData = {
        ...finalData,
        order_status: 4,
        id: props?.data?._id,
        deliveryPerson: {
          name: "",
          link: trackingUrl,
          phoneNumber: "",
        },
      };
      let response = await axios.patch(
        `${serverApi}/ordering/${finalData?.id}`,
        finalData,
        {
          headers: { Authorization: props?.accessToken },
        }
      );
      if (response.status == 200) {
        setOpen(false);
        if (props?.getUpdatedData) props.getUpdatedData();
      } else {
        errorAlert("Something went wrong!");
      }
    } else if (!trackingUrl && thirdParty) {
      setErrorTrackingUrl("Required field!");
    }
  };
  const handleModal = async () => {
    if (
      !props?.data?.deliveryPerson?.name &&
      !props?.data?.deliveryPerson?.phoneNumber
    ) {
      setOpen(true);
    }
    if (
      props?.data?.deliveryPerson?.name &&
      props?.data?.deliveryPerson?.phoneNumber
    ) {
      setOpen(false);
      await onSubmit(true);
    }
  };
  const thirdPartyDeliveryRef = useRef();
  const showDeliveryPerson = () => {
    if (thirdPartyDeliveryRef) {
      setOpen(false);
      thirdPartyDeliveryRef.current.handleShow();
    }
  };
  const [showAdd, setShowAdd] = useState(false);

  const dispatch = useDispatch();

  const onClickAddEditDeliveryPerson = (data) => {
    const token = props.accessToken;
    dispatch(add_delivery_person(token, data));
    getDeliveryPersons();
    setShowAdd(false);
    setOpen(true);
  };

  const handleCloseAdd = () => {
    setShowAdd(false);
  };

  const [errorTrackingUrl, setErrorTrackingUrl] = useState(null);

  return (
    <div>
      <React.Fragment>
        <AddOrEditDeliveryPersonModal
          showAddEdit={showAdd}
          handleCloseAdd={handleCloseAdd}
          onValueRedirect={onClickAddEditDeliveryPerson}
          actionData={null}
        />
        <DeliveryPerson
          id={props?.data?._id}
          deliveryPerson={null}
          edit={true}
          hide={true}
          ref={thirdPartyDeliveryRef}
          onClose={() => setOpen(false)}
        />
        <div variant="div" align="center">
          {props?.mobile ? (
            <button
              className="btn btn-success font_10_m popup-save-button"
              type="button"
              style={{
                width: "100px",
                minHeight: "48px",
              }}
            >
              {props?.buttonText ? props?.buttonText : "Out for Delivery"}
            </button>
          ) : props?.edit ? (
            <div onClick={() => setOpen(true)}>
              <div
                className="f12-400 px-3 py-2 mt-2 d-flex align-items-center"
                style={{
                  cursor: "pointer",
                  color: "white",
                  backgroundColor: "#EE3A23",
                  borderRadius: "5px",
                }}
                align="left"
              >
                <div className="mr-1">Change Delivery person</div>
                <Image
                  src={require("../../../assets/images/Icon/bxs_edit.png")}
                  width={20}
                />
              </div>
            </div>
          ) : (
            <>
              {props?.iconButton ? (
                <div
                  className="border f12-400 pr-6 py-2 mt-2 pl-1"
                  style={{ cursor: "pointer" }}
                  align="left"
                  onClick={() => setOpen(true)}
                >
                  Assign Delivery person
                </div>
              ) : (
                <div onClick={handleModal}>
                  <Image
                    src={require("../../../assets/images/iconButton/right_arrow_green.svg")}
                    alt={
                      props?.buttonText
                        ? props?.buttonText
                        : "Ready for Delivery"
                    }
                    title={
                      props?.buttonText
                        ? props?.buttonText
                        : "Ready for Delivery"
                    }
                    fluid
                    width="40"
                  />
                  {/* change */}
                  <div className="f10-500">
                    {props?.buttonText
                      ? props?.buttonText
                      : "Ready for Delivery"}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        <Modal show={open} onHide={() => setOpen(false)} centered>
          <Modal.Header className="py-0 pt-3 border-0" closeButton>
            <Modal.Title className="f24-700">
              Assign Delivery Person
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading ? (
              <SmallLoader />
            ) : (
              <div className="assign-delivery-persons-modal">
                <div className="f16-400">Select Delivery Person</div>
                <Row
                  style={{
                    backgroundColor: "#ffffff",
                    paddingTop: "15px",
                    paddingBottom: "15px",
                  }}
                  className="align-items-center border-bottom"
                >
                  <Col md={1} xs={1} className="column">
                    <Radio
                      checked={thirdParty}
                      onChange={(e) => {
                        setSelectedDeliveryPerson();
                        setThirdParty(true);
                        // showDeliveryPerson();
                      }}
                      sx={{
                        "&.Mui-checked": {
                          color: "red",
                        },
                      }}
                      value={"NEW"}
                      name="radio-button-demo"
                      color="primary"
                      inputProps={{ "aria-label": "New Address" }}
                    />
                  </Col>
                  <Col md={11} xs={11} className="column">
                    <div className={"f14-500"}>Third Party Delivery</div>
                  </Col>
                </Row>
                {!noDeliveryPerson && deliveryPersons?.length
                  ? deliveryPersons.map((deliveryPerson) => {
                      return (
                        <Row
                          style={{
                            backgroundColor: "#ffffff",
                            paddingTop: "15px",
                            paddingBottom: "15px",
                          }}
                          className="align-items-center border-bottom"
                        >
                          <Col md={1} xs={1} className="column">
                            <Radio
                              checked={
                                selectedDeliveryPerson?._id ===
                                deliveryPerson?._id
                              }
                              onChange={(e) => {
                                setThirdParty(false);
                                setErrorTrackingUrl(null);
                                setSelectedDeliveryPerson(deliveryPerson);
                              }}
                              name="radio-button-demo"
                              inputProps={{ "aria-label": "Delivery Person" }}
                            />
                          </Col>
                          <Col md={7} xs={7} className="column">
                            <div className={"f14-500"}>
                              {deliveryPerson?.full_name || ""}
                            </div>
                            <div
                              className={"f12-400 d-flex align-items-center"}
                            >
                              {deliveryPerson?.gender?.[0] || ""}
                              <div className="ml-1">
                                {deliveryPerson?.age || ""}
                              </div>
                            </div>
                          </Col>
                          <Col md={4} xs={4} className="column">
                            <div
                              className={"f12-400 d-flex align-items-center"}
                            >
                              {deliveryPerson?.country_code || ""}&nbsp;
                              {deliveryPerson?.mobile_number || ""}
                            </div>

                            <div className={"d-flex justify-content-center"}>
                              <div
                                className={`f10-400 badge badge-pill badge-${
                                  deliveryPerson?.runningStatus == "AVAILABLE"
                                    ? "success"
                                    : deliveryPerson?.runningStatus ==
                                      "OCCUPIED"
                                    ? "warning"
                                    : "light"
                                } px-2 py-1`}
                                style={{
                                  textTransform: "capitalize",
                                  color:
                                    deliveryPerson?.runningStatus == "AVAILABLE"
                                      ? "white"
                                      : "inherit",
                                }}
                              >
                                {deliveryPerson?.runningStatus || ""}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      );
                    })
                  : null}
                <div
                  className="d-flex align-items-center f14-400 mx-3  my-4"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpen(false);
                    setShowAdd(true);
                  }}
                >
                  <Image
                    src={require("../../../assets/images/Icon/mdi_user-add.png")}
                    width={20}
                  />
                  <div className="ml-2 f14-500">Add New Delivery Person</div>
                </div>
                <div className="mx-3 my-4">
                  <div className="f12-400 mb-1">
                    Tracking URLs {thirdParty ? "*" : null}
                  </div>
                  <TextField
                    label="Enter Tracking URL"
                    variant="outlined"
                    fullWidth
                    type="url"
                    disabled={!thirdParty}
                    value={trackingUrl}
                    error={errorTrackingUrl}
                    onChange={(e) => setTrackingUrl(e.target.value)}
                  />
                  <div className="f10-500 text-danger">{errorTrackingUrl}</div>
                </div>
              </div>
            )}
            <div className="d-flex align-items-center pt-4">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                style={{ border: "2px solid #ee3a23" }}
                className="btn-lg mr-4 px-5 w-100"
                onClick={onSubmit}
              >
                Confirm Assignment
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </div>
  );
}

export default AssignDeliveryPerson;
